import React from 'react';
import { 
    Card, 
    CardContent, 
    Stack, 
    Skeleton, 
    Box 
} from '@mui/material';

const UserActionCardSkeleton: React.FC = () => {
    return (
        <Card
            sx={{
                backgroundColor: '#FAF9F9',
                borderRadius: '16px',
                boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
                border: '2px solid #E0E0E0'
            }}
        >
            <CardContent>
                <Stack spacing={1}>
                    {/* Action */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={60}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={100}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>

                    {/* Account Number */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={100}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={120}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>

                    {/* SA ID */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={50}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={80}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>

                    {/* User */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={40}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={90}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>

                    {/* Timestamp */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={80}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={140}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default UserActionCardSkeleton;
